import { render, staticRenderFns } from "./ProfileTalentTagline.vue?vue&type=template&id=2dcf2393"
import script from "./ProfileTalentTagline.vue?vue&type=script&lang=js"
export * from "./ProfileTalentTagline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports